<template>
  <v-card>
    <v-card-title>
      Deliverables
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :search="search"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <a
          v-if="item.name != 'Ganeral Data'"
          :href="`${publicPath}${item.name}`"
          download
        >
          <v-icon small class="mr-2"> mdi-file </v-icon>
        </a>
        <v-icon v-if="item.name == 'Ganeral Data'" small class="mr-2">
          mdi-file
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize"> Reset </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import { GetFormatDateType1 } from "../../../util/dateFunction";
mapGetters;
export default {
  data: () => ({
    publicPath: process.env.BASE_URL,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Name Report",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Date", value: "date" },
      { text: "Phase", value: "phase" },
      { text: "Process", value: "process" },
      { text: "Consultant", value: "consultant" },
      { text: "Actions", value: "actions", sortable: false, align: "center" },
    ],
    desserts: [],
    defaultItem: {
      name: "General Data",
      consultant: "Andre J.",
      date: "28/01/2021",
      phase: "1",
      process: "1.1",
    },
  }),
  computed: {
    ...mapGetters(["getProcessSelected"]),
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    getProcessSelected() {
      this.reportsDownload();
    },
  },
  methods: {
    initialize() {
      // this.desserts = [
      //   {
      //     name: "Ganeral Data",
      //     consultant: "Andre J.",
      //     date: "28/01/2021",
      //     phase: "1",
      //     process: "1.1",
      //   },
      //   {
      //     name: "Ganeral Data",
      //     consultant: "Andre J.",
      //     date: "28/01/2021",
      //     phase: "1",
      //     process: "1.1",
      //   },
      // ];
    },

    // editItem(item) {
    //   console.log("Download", item);
    // },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    reportsDownload() {
      const { id } = this.getProcessSelected;
      switch (id) {
        case "2.3":
          this.desserts = [
            {
              name: "2.3 Well Selection Indicator V1_up.xlsx",
              consultant: "Martín Essenfeld",
              date: GetFormatDateType1("2021/02/23"),
              phase: "2",
              process: "2.3",
            },
          ];
          break;
        case "2.5":
          this.desserts = [
            {
              name: "2.5 Plan_Operacional_RISK_up.xlsx",
              consultant: "Martín Essenfeld",
              date: GetFormatDateType1("2021/02/23"),
              phase: "2",
              process: "2.5",
            },
          ];
          break;
        case "5.1":
          this.desserts = [
            {
              name: "5.1 Lessons Learned Template_up.xlsx",
              consultant: "Martín Essenfeld",
              date: GetFormatDateType1("2021/02/23"),
              phase: "5",
              process: "5.1",
            },
          ];
          break;
        case "6.1":
          this.desserts = [
            {
              name: "6.1a - Pampa--Templ_Final_Report_up.pdf",
              consultant: "Martín Essenfeld",
              date: GetFormatDateType1("2021/02/23"),
              phase: "6",
              process: "6.1",
            },
            {
              name: "6.1a - Pampa--Templ_Report by Process_up.pdf",
              consultant: "Martín Essenfeld",
              date: GetFormatDateType1("2021/02/23"),
              phase: "6",
              process: "6.1",
            },
          ];
          break;
        case "1.1":
          this.desserts = [
            {
              name: "1.1a - Pampa--Templ_Report_Data_Diag_up.pdf",
              consultant: "Martín Essenfeld",
              date: GetFormatDateType1("2021/01/15"),
              phase: "1",
              process: "1.1",
            },
          ];
          break;
        case "2.9":
          this.desserts = [
            {
              name: "2.9a - Pampa--Templ_Report_Company Selec_up.pdf",
              consultant: "Martín Essenfeld",
              date: GetFormatDateType1("2021/01/15"),
              phase: "2",
              process: "2.9",
            },
          ];
          break;
        case "4.1":
          this.desserts = [
            {
              name:
                "4.1a - Pampa--Templ_Report_Operation_Res_up.pdf",
              consultant: "Martín Essenfeld",
              date: GetFormatDateType1("2021/01/15"),
              phase: "4",
              process: "4.1",
            },
          ];
          break;
        case "2.1":
          this.desserts = [
            {
              name: "2.1a - Pampa--Templ_Report_Design_up.pdf",
              consultant: "Martín Essenfeld",
              date: GetFormatDateType1("2021/01/15"),
              phase: "2",
              process: "2.1",
            },
          ];
          break;
        case "2.7":
          this.desserts = [
            {
              name: "2.7a - Pampa--Templ_Report_Economic Eval_up.pdf",
              consultant: "Martín Essenfeld",
              date: GetFormatDateType1("2021/01/15"),
              phase: "2",
              process: "2.7",
            },
          ];
          break;
        case "1.2":
          this.desserts = [
            {
              name: "1.2a - Pampa--Templ_Report_Screening_up.pdf",
              consultant: "Martín Essenfeld",
              date: GetFormatDateType1("2021/01/15"),
              phase: "1",
              process: "1.2",
            },
          ];
          break;

        default:
          break;
      }
    },
  },
  created() {
    this.initialize();
    this.reportsDownload();
  },
};
</script>